<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
      ref="table"
      :max-items="20"
      pagination
      search
      v-if="contacts !== null"
      :data="contacts"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span
              class="ml-2 text-base text-primary"
              @click.stop="openCreatePopup"
            >Contact toevoegen</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Naam</vs-th>
        <vs-th sort-key="email">Email</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            @click.native="openPopup(tr)"
          >
            <vs-td>
              <p
                class="deliverer-name"
              >{{ tr.insertion !== null ? tr.firstname + ' ' + tr.insertion + ' ' + tr.lastname : tr.firstname + ' ' + tr.lastname }}</p>
            </vs-td>

            <vs-td>
              <p class="deliverer-phone_number">{{ tr.email }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <ht-contact-popup></ht-contact-popup>
  </div>
</template>
<script>
import HtContactPopup from "../ContactPopup";

export default {
  components: {
    HtContactPopup,
  },
  data() {
    return {
      contacts: null,
      selected: [],
    };
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.params.slug !== null) {
        this.getCompanyContacts();
      }
    },
  },

  computed: {
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
        return false;
      }
    },

    getName() {
      return (
        deliverer.firstname +
        (deliverer.insertion !== null ? deliverer.insertion : "") +
        deliverer.lastname
      );
    },
  },
  methods: {
    openPopup(contact) {
      this.$events.fire("open-contact-popup", contact);
    },
    openCreatePopup() {
      this.$events.fire("open-create-contact-popup");
    },
    getCompanyContacts() {
      let url = this.staffRoute
        ? "https://staffapi.hebtrek.nl/v1/company/" +
          this.$route.params.slug +
          "/company-contacts"
        : "https://companyapi.hebtrek.nl/v1/company/" +
          this.$route.params.slug +
          "/company-contacts";
      let token = this.staffRoute
        ? JSON.parse(localStorage.getItem("stafftoken"))
        : JSON.parse(localStorage.getItem("companytoken"));
      this.$http
        .get(url, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          this.contacts = response.data;
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Oeps!",
            text:
              "(" + error.response.status + ") " + error.response.data.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            fixed: true,
            position: "top-center",
          });
        });
    },
  },
  mounted() {
    this.getCompanyContacts();
    this.$events.listen("refresh-contacts", () => {
      this.getCompanyContacts();
    });
  },
};
</script>
